module.exports = __webpack_public_path__ + "../resources/images/SkyCode_5-b6aa83c8225978da28e3ae8f6b6625f9.svg";